import { applyInterpolation } from 'automation-ui-action-features/actions/extension/utils/interpolation-utils';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import ActionMetadata, { renderActionLabel } from 'automation-ui-action-features/records/ActionMetadata';
import upperFirst from 'hs-lodash/upperFirst';
function isIntegratorAction(extensionDefinition) {
  return 'appName' in extensionDefinition;
}
function isIntegratorActionAEv2(extensionDefinition) {
  return 'displaySettings' in extensionDefinition || 'integrationName' in extensionDefinition;
}
class ExtensionActionMetadataDefinition extends ActionMetadata {
  constructor(_extensionDefinitions) {
    super({
      type: ActionTypes.AUTOMATION_EXTENSION,
      typeId: '0-16',
      extensionDefinitions: _extensionDefinitions || {}
    });
    this.getActionLabel = (prefix, actionLink, useString, action) => {
      const actionMetadata = action.getMetadata();
      const extensionDefinitions = this.getExtensionDefinitions() || {};
      const extensionDefinition = extensionDefinitions[actionMetadata.getActionTypeId()];
      const descriptionString = extensionDefinition ? extensionDefinition.actionName : '';
      const actionLabel = applyInterpolation(upperFirst(descriptionString), {
        appName: extensionDefinition ? this.getAppName(extensionDefinition) : undefined
      });
      return renderActionLabel({
        prefix,
        actionLink,
        actionLabel,
        useString
      });
    };
    this.getAppName = extensionDefinition => {
      if (isIntegratorAction(extensionDefinition)) {
        return extensionDefinition.appName;
      }
      if (isIntegratorActionAEv2(extensionDefinition)) {
        const {
          displaySettings,
          integrationName
        } = extensionDefinition;
        return displaySettings && displaySettings.appDisplayName ? displaySettings.appDisplayName : integrationName || undefined; // prevent returning null
      }
      return undefined;
    };
  }
  getExtensionDefinitions() {
    return this.extensionDefinitions;
  }

  /**
   * For now, we're creating these labels by using the counter
   * label prefix algorithm to generate 1-indexed counters
   * and prefixing them to the action labels. In the future,
   * we may move to allowing customers to set these.
   *
   * This function takes an optional url to redirect to on
   * click. It wraps the label.
   *
   * The `useString` optional argument
   * will return a string over a
   * React component
   */
  // TODO: Cannot overload the function with different parameters https://hubspot.slack.com/archives/C017FT4P2Q0/p1652280239485969
  /**
   * HubSpot-built actions do not have App Names. They are grouped using
   * listingCategory.
   */
}
export default ExtensionActionMetadataDefinition;